import { render } from "./MySubscriptions.vue?vue&type=template&id=6b3f1940&scoped=true"
import script from "./MySubscriptions.vue?vue&type=script&lang=js"
export * from "./MySubscriptions.vue?vue&type=script&lang=js"

import "./MySubscriptions.vue?vue&type=style&index=0&id=6b3f1940&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3f1940"]])

export default __exports__